export default __webpack_public_path__ + "static/media/Heart.1b272643.svg";